import { render, staticRenderFns } from "./PartOfSpeechSelect.vue?vue&type=template&id=c60bfa12&"
import script from "./PartOfSpeechSelect.vue?vue&type=script&lang=js&"
export * from "./PartOfSpeechSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports